import { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { MdClose } from "react-icons/md";
import { Link } from "react-router-dom";

export const CagnottePopup = () => {
  const [isOpen, setIsOpen] = useState(true);
  const closeButtonRef = useRef(null);
  const firstFocusableRef = useRef(null);

  // Gestion du scroll et focus
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
      closeButtonRef.current?.focus();
    } else {
      document.body.style.overflow = "auto";
    }
    return () => (document.body.style.overflow = "auto");
  }, [isOpen]);

  if (!isOpen) return null;

  // Animation container
  const backdropVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  };

  const modalVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { opacity: 1, scale: 1, transition: { type: "spring", stiffness: 300, damping: 25 } },
  };

  return (
    <motion.div
      role="dialog"
      aria-modal="true"
      aria-labelledby="popup-title"
      aria-describedby="popup-desc"
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4"
      variants={backdropVariants}
      initial="hidden"
      animate="visible"
    >
      <motion.div
        className="bg-white rounded-xl shadow-xl w-full max-w-md p-6 relative text-center"
        variants={modalVariants}
      >
        {/* Bouton fermer */}
        <button
          ref={closeButtonRef}
          onClick={() => setIsOpen(false)}
          aria-label="Fermer la cagnotte"
          className="absolute top-4 right-4 text-gray-600 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-600 rounded"
        >
          <MdClose size={24} />
        </button>

        {/* Titre */}
        <h2 id="popup-title" className="text-2xl font-semibold text-[#8F9324] mb-4">
          Participez à notre cagnotte !
        </h2>

        {/* Description */}
        <p id="popup-desc" className="text-gray-700 mb-6">
          Aidez-nous à offrir un cadre éducatif de qualité aux enfants. Chaque contribution compte !
        </p>

        {/* Bouton CTA */}
        <Link
          ref={firstFocusableRef}
          to="/nous-soutenir"
          className="inline-block px-6 py-3 text-lg bg-[#8F9324] text-white font-medium rounded-lg shadow-md hover:bg-[#7a8120] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#8F9324] transition-colors"
        >
          Découvrir la cagnotte
        </Link>
      </motion.div>
    </motion.div>
  );
};
